import React, { ReactNode } from 'react';
import { Card, ErrorMessage, FormCell, Grid, Header2Text, Notification, SpacerRow } from 'ui-toolkit';
import { ActualBalanceMoneyLabel } from '../ActualBalanceLabel';
import { AvailableBalanceMoneyLabel } from '../AvailableBalanceLabel';
import styled, { DefaultTheme, withTheme } from 'styled-components';
import { FundingCompleteContainer } from 'components/order/fees/FundingCompleteContainer';

export interface IEscrowBalancesHeaderProps {
  actual: ReactNode;
  available: ReactNode;
  totalDeposits: ReactNode;
  totalDisbursements: ReactNode;
  onCompleteFunding?: () => void;
  error?: Error;
  success?: boolean;
  theme?: DefaultTheme;
}

const SpaEscrowBalancesHeader_: React.FC<IEscrowBalancesHeaderProps> = ({
  actual,
  available,
  totalDeposits,
  totalDisbursements,
  error,
  success,
  theme,
}) => {
  return (
    <StyledCard contentPadding={theme?.spacing.spacing7}>
      <Header2Text>Balances</Header2Text>
      <SpacerRow />
      <ErrorMessage error={error} />
      {success && <Notification type={'success'}>Funded At successfully set</Notification>}
      <RoomyGrid columnCount={2}>
        <FormCell label={<ActualBalanceMoneyLabel />}>{actual}</FormCell>
        <FormCell label={`Total Deposits`}>{totalDeposits}</FormCell>
        <FormCell label={<AvailableBalanceMoneyLabel />}>{available}</FormCell>
        <FormCell label={`Total Disbursements`}>{totalDisbursements}</FormCell>
      </RoomyGrid>
      <SpacerRow />
      <Grid>
        <FundingCompleteContainer />
      </Grid>
      <SpacerRow />
    </StyledCard>
  );
};

const StyledCard = styled(Card)`
  grid-column-start: 2;
  grid-column-end: 4;
`;
const RoomyGrid = styled(Grid)`
  gap: ${(props) => props.theme.spacing.spacing5};
`;

export const SpaEscrowBalancesHeader = withTheme(SpaEscrowBalancesHeader_);
